module.exports = __webpack_public_path__ + "img/D0011.1ae46017.svg";